import Suffix from './Suffix'

export default Suffix
